/**
 * Click-to-open lightbox for the house detail page's photo gallery.
 * Built on the native <dialog> element — showModal()/close() already give
 * Escape-to-close and modal focus handling for free, so this only needs to
 * wire up click-outside-to-close, prev/next, and arrow-key navigation.
 */

const lightbox = document.querySelector('[data-gallery-lightbox]');
const gallery = document.querySelector('.house-page__gallery');

if (lightbox && gallery) {
  const image = lightbox.querySelector('[data-gallery-image]');
  const counter = lightbox.querySelector('[data-gallery-counter]');
  const triggers = Array.from(gallery.querySelectorAll('[data-gallery-trigger]'));
  let currentIndex = 0;

  function show(index) {
    currentIndex = (index + triggers.length) % triggers.length;
    const trigger = triggers[currentIndex];
    image.src = trigger.dataset.fullSrc;
    image.alt = trigger.dataset.alt || '';
    counter.textContent = `${currentIndex + 1} / ${triggers.length}`;
  }

  triggers.forEach((trigger, index) => {
    trigger.addEventListener('click', () => {
      show(index);
      lightbox.showModal();
    });
  });

  lightbox.querySelector('[data-gallery-close]').addEventListener('click', () => lightbox.close());
  lightbox.querySelector('[data-gallery-prev]').addEventListener('click', () => show(currentIndex - 1));
  lightbox.querySelector('[data-gallery-next]').addEventListener('click', () => show(currentIndex + 1));

  // Swipe (touch) / drag (mouse) navigation on the photo itself — the arrow
  // buttons and arrow keys were previously the only way to move between
  // photos, which doesn't match how every native photo viewer behaves.
  // Pointer Events cover touch and mouse with the same code.
  const SWIPE_THRESHOLD = 50;
  let pointerStart = null;

  image.addEventListener('pointerdown', (event) => {
    pointerStart = { x: event.clientX, y: event.clientY };
  });

  image.addEventListener('pointerup', (event) => {
    if (!pointerStart) return;
    const deltaX = event.clientX - pointerStart.x;
    const deltaY = event.clientY - pointerStart.y;
    pointerStart = null;
    // Ignore short taps and mostly-vertical drags (not a page-navigation
    // gesture) — only a clear enough horizontal swipe moves the gallery.
    if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) return;
    show(deltaX < 0 ? currentIndex + 1 : currentIndex - 1);
  });

  image.addEventListener('pointercancel', () => {
    pointerStart = null;
  });

  // Clicking the backdrop area closes the dialog — a click lands directly
  // on the <dialog> element itself only when it misses every child control.
  lightbox.addEventListener('click', (event) => {
    if (event.target === lightbox) lightbox.close();
  });

  lightbox.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowRight') show(currentIndex + 1);
    if (event.key === 'ArrowLeft') show(currentIndex - 1);
  });
}
